import { cn } from '@/utils';
import { memo } from 'react';

import { Spin } from 'antd';
import { SpinProps, SpinSize } from 'antd/es/spin';

interface LoadingProps extends SpinProps {
	isLoading?: boolean;
	size?: SpinSize;
	className?: string;
}

const Loading = ({
	isLoading = false,
	size = 'default',
	className,
	...props
}: LoadingProps) => {
	if (!isLoading) {
		return null;
	}
	return (
		<div
			className={cn(
				'absolute center h-screen top-0 left-0 right-0 z-[99999999]',
				className
			)}
		>
			<Spin
				className={className ? 'm-0' : 'xl:ml-[290px] mt-[-200px]'}
				tip="Loading"
				size={size}
				{...props}
			/>
		</div>
	);
};

export default memo(Loading);
